/* eslint-disable indent */
import { makeStyles } from '@material-ui/core';
import DialogList from 'components/DialogList';
import Modal from 'components/Modal';
import React from 'react';
import useWindowDimensions from 'hooks/useWindowWidth';
import clsx from 'clsx';
import {
  CompanyData,
  RolesEnum,
  PermissionsData,
} from 'modules/authenticate/interfaces';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { superUser } from 'utils/helpers';
import { useLocation } from 'react-router';
import SideNavBar from './SideNavBar';
import styles from './styles';
import TopNavBar from './TopNavBar';

interface OwnProps {
  companySelected: CompanyData | null;
  component: React.ReactNode;
  permissions?: PermissionsData;
  role?: RolesEnum;
}

const useStyles = makeStyles(styles);

const Dashboard: React.FC<OwnProps> = ({
  companySelected,
  component,
  permissions,
  role,
}) => {
  const classes = useStyles();

  const [sideOpened, setSideOpened] = React.useState(false);
  const [dialogListOpened, setDialogOpened] = React.useState<
    'company' | 'partner' | null
  >(
    !companySelected && !superUser(role) && !permissions?.can_view_all_resources
      ? 'company'
      : null
  );

  const openDialogList = (type: 'company' | 'partner') => setDialogOpened(type);

  const toggleMenu = () => setSideOpened(!sideOpened);
  const { width } = useWindowDimensions();
  const { pathname } = useLocation();

  React.useEffect(() => {
    if (
      !permissions?.can_view_all_resources &&
      !companySelected &&
      !superUser(role)
    ) {
      setDialogOpened('company');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      <div className={classes.root}>
        <TopNavBar
          toggleMenu={toggleMenu}
          openSelectCompany={() => openDialogList('company')}
          openSelectPartner={() => openDialogList('partner')}
        />
        <SideNavBar
          open={sideOpened}
          width={width}
          onOpen={() => setSideOpened(true)}
          onClose={() => setSideOpened(false)}
        />

        <div
          className={clsx(classes.content, {
            [classes.contentMobile]: width <= 600,
          })}
        >
          <div className={classes.container}>{component}</div>
        </div>
      </div>
      <DialogList
        open={dialogListOpened}
        setListOpened={value => setDialogOpened(value)}
        onClose={() => setDialogOpened(null)}
      />
      <Modal />
    </>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  companySelected,
  permissions: data?.permissions,
  role: data?.role,
});

export default connect(mapStateToProps)(Dashboard);
